export const can = (user, perm) => !!user && (user.role === "admin" || user.is_platform_admin || (user.perms || []).includes(perm));
